/// <amd-module name="Artifacts/PackageRecycleBin/types/Index" />

export * from "Artifacts/PackageRecycleBin/types/IDeletedPackageVersion";
